import React from "react";
import { DialogId } from "../../services/Dialogs/dialog-ids";
import { DialogParamsById, DialogRegistry } from "../../services/Dialogs/types";

export const getDialogComponent = <K extends DialogId>(
  dialogs: DialogRegistry,
  dialogId: K
): React.ComponentType<DialogParamsById[K]> | undefined => {
  return dialogs[dialogId] as React.ComponentType<DialogParamsById[K]> | undefined;
};
